import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import * as Typed from 'typed.js';
import { ModalService } from '../../../_common/modal/modal-service';

@Component({
  selector: 'app-main-banner',
  templateUrl: './main-banner.component.html',
  styleUrls: ['./main-banner.component.scss'],
})
export class MainBannerComponent implements OnInit {
  @ViewChild('resume') resume: ElementRef;

  years = 10;
  resFiles = false;

  // String Typing Options
  options = {
    strings: [
      `<span class="space"></span>Hi, I'm a UX expert <span class="me"></span><br> with
      solid <span class="line">coding</span> skills`,
    ],
    typeSpeed: 50,
    backSpeed: 50,
    startDelay: 300,
    loop: false,
    loopCount: Infinity,
    backDelay: 700,
    smartBackspace: true,
  };

  constructor(private _ModalService: ModalService) {}

  resumeFiles() {
    this.resFiles = true;
    this._ModalService.createModal(this.resFiles);
    this._ModalService.setContent(this.resume);
  }

  ngOnInit() {
    const typed = new (Typed as any)('#typed-strings', this.options);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/main-banner/main-banner.component.ts